import { FOUNDATION } from "../../constants"

export const REPLACE_NAVBAR_ELEMENTS = `${FOUNDATION}_REPLACE_NAVBAR_ELEMENTS`

export const CLEAR_NAVBAR_ELEMENTS = `${FOUNDATION}_CLEAR_NAVBAR_ELEMENTS`
